import React from 'react';
import API from 'shared/constants/api';
import { hrefSet } from 'shared/actions/partsForm';
import TITLE from 'shared/constants/seoTitles';
import queryString from 'query-string';
import DESCRIPTION from 'shared/constants/seoDescriptions';
import { setTargetingArguments } from 'shared/actions/globals';
import LINKS from 'desktop/constants/navigation';
import { removeLocaleFromHref } from 'shared/helpers/locale';
import {
  getAdvertOgImage,
  getPriceWithCurrency,
  isLocationCountry,
} from 'shared/helpers/transportInfo';
import { resultsThunks } from 'shared/actions/searchForm';
import { getAdsContext, getPriceValuation } from 'shared/helpers/adsAndMetrics';
import { getIdFromSpareUrl } from 'shared/helpers/urls';
import Layout from '../../../components/Layout';
import SparepartsSinglePage from './SparepartsSinglePage';

async function action({ baseUrl, path, store, fetch, params = {}, translate }) {
  const { id: slug } = params;
  const stoRequest = {};
  let stoUrl = API.KATALOG_KOMPANIY_STO;
  if (!slug) {
    return null;
  }

  const id = getIdFromSpareUrl(slug) ? getIdFromSpareUrl(slug) : slug;
  const advert = await fetch(API.SPARE_PARTS.ITEM(id)).then(r => {
    if (r.ok) {
      return r && r.json && r.json();
    }

    return null;
  });

  if (!advert || !advert.id) {
    return null;
  }

  const url = removeLocaleFromHref(`${baseUrl}${path}`.replace('//', '/'));
  const {
    vehicle_type: type,
    rubric,
    sparetypes,
    make,
    models,
    price: prices,
    location,
    is_customs_cleared: isCustomsCleared,
    is_new: isNew,
  } = advert;

  const similarParams = Object.entries({
    rubric: rubric ? rubric.id : null,
    sparetype: sparetypes && sparetypes.length > 0 ? sparetypes[0].id : null,
    make: make ? make.id : null,
    year_from: advert.year_from || null,
    year_to: advert.year_to || null,
  })
    .filter(([key, value]) => key !== null && value !== null && value !== undefined)
    .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});

  const similar = await fetch(API.SPARE_PARTS.ALL(`?${queryString.stringify(similarParams)}`)).then(
    r => r.json(),
  );
  const similarSpares = similar ? similar.results.filter(spare => spare.id !== parseFloat(id)) : [];

  const price = getPriceWithCurrency(prices, 'uah');
  const sparetype = sparetypes && sparetypes.length > 0 ? sparetypes[0] : null;
  const model = models && models.length > 0 ? models[0] : null;
  const metaParams = { rubric, sparetype, type, make, model };

  const title = TITLE.SPARE_ADVERT({ ...metaParams, id, price }, translate);
  const description = DESCRIPTION.SPARE_ADVERT({...metaParams, id}, translate);

  const contextPrice = prices && prices.length && prices[0];
  const targetingArguments = getAdsContext({
    id,
    rubric,
    make,
    transport: type,
    model,
    isNew,
    location,
    isCustomCleared: typeof isCustomsCleared === 'boolean' ? isCustomsCleared : undefined,
    isCountry: isLocationCountry(location),
    price: getPriceValuation({ from: contextPrice.value }, contextPrice.currency),
  });

  const ogImage = getAdvertOgImage(advert);
  store.dispatch(setTargetingArguments(targetingArguments));
  if (location && location.id) {
    stoRequest.location = location.id;
    stoUrl = `${stoUrl}${location.slug}`;
  }
  if (make) {
    stoRequest.makes = make.id;
  }
  /* Autobooking data */
  const queryObj = {
    ...stoRequest,
    per_page: 5,
    is_top_service: 1,
    shuffle: 1,
  };
  await store.dispatch(
    hrefSet({
      query: queryObj,
      url: stoUrl,
    }),
  );
  await store.dispatch(resultsThunks.searchFirmsResults(queryObj, { name: 'topFirms', topMakesFilter: false }));
  return {
    chunks: ['advert-auto-part'],
    title,
    description,
    ogImage,
    routeName: 'auto-parts',
    type: 'advert',
    component: (
      <Layout navLinks={LINKS.SPARES} currentRoute={url}>
        <SparepartsSinglePage isSpare key={advert.id} advertInfo={advert} similar={similarSpares} />
      </Layout>
    ),
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/desktop/routes/spareparts/spareparts-singlepage/index.js